import {Account, User} from './models';
import {getPassportHref} from './utils';

export enum PassportLoginAction {
    SwitchUser = 'change_default',
    Logout = 'logout',
}

function createElement(name: string, attrs: Record<string, string>) {
    const el = document.createElement(name);
    Object.keys(attrs).forEach((key) => {
        el.setAttribute(key, attrs[key]);
    });
    return el;
}

export interface SubmitPassportFormProps {
    account: Account;
    currentUser: User;
    action: PassportLoginAction;
    internal?: boolean;
    retpath?: string;
}

export function submitPassportForm({
    account,
    currentUser,
    action,
    internal,
    retpath = location.href,
}: SubmitPassportFormProps) {
    const {uid} = account;
    const {yandexuid} = currentUser;

    const form = createElement('form', {
        style: 'position: absolute; display: none;',
        method: 'POST',
        action: `${getPassportHref(internal)}/passport?mode=embeddedauth`,
    });
    const actionInput = createElement('input', {name: 'action', value: action});
    const retpathInput = createElement('input', {name: 'retpath', value: retpath});
    const yuInput = createElement('input', {name: 'yu', value: yandexuid});
    const uidInput = createElement('input', {name: 'uid', value: uid});
    const submit = createElement('button', {type: 'submit'});

    form.appendChild(actionInput);
    form.appendChild(retpathInput);
    form.appendChild(yuInput);
    form.appendChild(uidInput);
    form.appendChild(submit);
    document.body.appendChild(form);

    const butt = form.querySelector('button');

    if (butt) {
        butt.click();
    }

    form.remove();
}
